<template>
  <div class="vx-row" id="pages">
    <div class="vx-col w-full">
      <vx-card>
        <form>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{ $t("Version") }}</label>
              <v-select
                label="name"
                name="pageType"
                :options="pageType"
                v-model="model.pageType"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('pageType')"
                >{{ errors.first("pageType") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="model.pageType == 1">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{
                $t("BannerPositionInDesktopVersion")
              }}</label>
              <v-select
                label="name"
                name="bannerTypeDesktop"
                :options="bannerTypes"
                v-model="model.bannerTypeDesktop"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerTypeDesktop')"
                >{{ errors.first("bannerTypeDesktop") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="model.pageType == 2">
            <div class="vx-col w-full">
              <label class="vs-select--label">{{
                $t("BannerPositionInMobileVersion")
              }}</label>
              <v-select
                label="name"
                name="bannerTypeMobile"
                :options="bannerTypeMobile"
                v-model="model.bannerTypeMobile"
                v-validate="{ required: true }"
                :reduce="x => x.id"
                dir="rtl"
              >
              </v-select>
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerTypeMobile')"
                >{{ errors.first("bannerTypeMobile") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="model.name"
                name="bannerTitle"
                :label="$t('Title')"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerTitle')"
                >{{ errors.first("bannerTitle") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="model.link"
                :label="$t('Link')"
              />
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("StartDate")
              }}</label>

              <date-picker
                v-model="model.startClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('StartDate')"
                name="startdate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('startdate')"
                >{{ errors.first("startdate") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <label class="vs-select--label datepicker-lb">{{
                $t("EndDate")
              }}</label>

              <date-picker
                v-model="model.expireClock"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('EndDate')"
                name="expiredate"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('expiredate')"
                >{{ errors.first("expiredate") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input
                class="inputx"
                v-model="model.priority"
                name="bannerPriority"
                v-validate="{ regex: '^([0-9]+)$' }"
                :label="$t('Priority')"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('bannerPriority')"
                >{{ errors.first("bannerPriority") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-4" v-if="model.pageType == 1">
            <div class="vx-col w-full">
              <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="images"
                :maxImage="1"
                :dragText="$t('DragAndDrop')"
                :browseText="$t('UploadImage')"
                :showPrimary="false"
              ></vue-upload-multiple-image>
            </div>
          </div>
          <div class="vx-row mb-4" v-if="model.pageType == 2">
            <div class="vx-col w-full">
              <vue-upload-multiple-image
                @upload-success="uploadImageSuccess"
                @before-remove="beforeRemove"
                @edit-image="editImage"
                :data-images="images"
                :maxImage="1"
                :dragText="$t('DragAndDrop')"
                :browseText="$t('UploadImage')"
                :showPrimary="false"
              ></vue-upload-multiple-image>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-2">
              <vs-button
                class="mb-2 submit-btn bg_l_green float-right mr-6"
                @click.prevent="submitForm"
                :disabled="disabled"
                >{{ $t("Submit") }}</vs-button
              >
              <router-link
                :to="{ path: '/Banners/Index' }"
                class="vs-component vs-button back-btn"
                color="rgb(62, 201, 214)"
                type="filled"
              >
                {{ $t("BackToList") }}
              </router-link>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
.date-picker label {
  width: 110px !important;
}
#my-strictly-unique-vue-upload-multiple-image {
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.image-bottom {
  direction: ltr;
}

.image-center {
  background-color: #f8f8f8;
}
.browse-text {
  color: #017572;
}
</style>
<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import "../../../assets/scss/vuesax-rtl/pages/_custom.scss";
import VueUploadMultipleImage from "vue-upload-multiple-image";

const dict = {
  custom: {
    bannerTitle: {
      required: "لطفا عنوان را وارد نمایید."
    },
    bannerPriority: {
      regex: "تنها مجاز به وارد کردن مقادیر عددی می‌باشید."
    },
    bannerTypeDesktop: {
      required: "لطفا محل قرارگیری بنر را انتخاب نمایید."
    },
    bannerTypeMobile: {
      required: "لطفا محل قرارگیری بنر را انتخاب نمایید."
    },
    pageType: {
      required: "لطفا نوع را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "ContentManagement_Banners_Create",
  data() {
    return {
      model: {
        pageType: null,
        bannerTypeDesktop: null,
        bannerTypeMobile: null,
        name: "",
        link: "",
        startClock: "",
        expireClock: "",
        priority: null,
        image: "",
        mobileImage: ""
      },
      pageType: [
        { name: "نسخه دسکتاپ", id: 1 },
        { name: "نسخه موبایل", id: 2 }
      ],
      bannerTypes: [
        { name: "اسلایدر اصلی، صفحه نخست", id: 1 },
        { name: "پنل زیراسلایدر صفحه نخست", id: 2 },
        { name: "1/2صفحه نخست", id: 7 },
        { name: "پرتال نمایندگان --- اسلایدر اصلی، صفحه نخست", id: 8 },
        { name: "پرتال نمایندگان --- پنل زیراسلایدر صفحه نخست", id: 9 },
        { name: "پرتال نمایندگان --- 1/2صفحه نخست", id: 14 }
      ],
      bannerTypeMobile: [
        { name: "اسلایدر اصلی، صفحه نخست", id: 1 },
        { name: "1/2 بالا، صفحه نخست", id: 2 },
        { name: "1/2پایین، صفحه نخست", id: 3 },
        { name: "تک بنر،بالای صفحه نخست", id: 4 },
        { name: "تک بنر،پایین صفحه نخست", id: 5 },
        { name: "پرتال نمایندگان --- اسلایدر اصلی، صفحه نخست", id: 6 },
        { name: "پرتال نمایندگان --- 1/2 بالا، صفحه نخست", id: 7 },
        { name: "پرتال نمایندگان --- 1/2پایین، صفحه نخست", id: 8 },
        { name: "پرتال نمایندگان --- تک بنر،بالای صفحه نخست", id: 9 },
        { name: "پرتال نمایندگان --- تک بنر،پایین صفحه نخست", id: 10 }
      ],
      disabled: false,
      images: []
    };
  },
  components: {
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
    VueUploadMultipleImage
  },

  methods: {
    ...mapActions({
      createBanner: "banner/create"
    }),

    uploadImageSuccess(formData, index, fileList) {
      if (this.model.pageType == 1) {
        this.model.image = fileList[index].path;
        this.model.mobileImage = "";
      }
      if (this.model.pageType == 2) {
        this.model.mobileImage = fileList[index].path;
        this.model.image = "";
      }
    },
    beforeRemove(index, done) {
      done();
      if (this.model.pageType == 1) {
        this.model.image = "";
      }
      if (this.model.pageType == 2) {
        this.model.mobileImage = "";
      }
    },
    editImage(formData, index, fileList) {
      if (this.model.pageType == 1) {
        this.model.image = fileList[index].path;
        this.model.mobileImage = "";
      }
      if (this.model.pageType == 2) {
        this.model.mobileImage = fileList[index].path;
        this.model.image = "";
      }
    },
    submitForm() {
      if (
        this.model.startClock == this.model.expireClock ||
        this.model.startClock > this.model.expireClock
      ) {
        this.$swal({
          position: "center-center",
          type: "error",
          text: "در انتخاب تاریخ ورودی و خروجی دقت نمایید!",
          showConfirmButton: false,
          timer: 8000
        });
      } else {
        this.$validator.validateAll().then(result => {
          this.disabled = true;
          if (result) {
            this.createBanner(this.model)
              .then(() => {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000
                });
              })
              .then(() => this.$router.push("/Banners/Index"));
          } else {
            // form have errors
            this.disabled = false;
          }
        });
      }
    }
  }
};
</script>
